import { render } from "./GradientSpinner.vue?vue&type=template&id=1b36d10b&scoped=true"
import script from "./GradientSpinner.vue?vue&type=script&lang=js"
export * from "./GradientSpinner.vue?vue&type=script&lang=js"

import "./GradientSpinner.vue?vue&type=style&index=0&id=1b36d10b&scoped=true&lang=css"

import exportComponent from "/home/adelaplace/PycharmProjects/pumping_tool_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b36d10b"]])

export default __exports__